export default __webpack_public_path__ + "static/media/home.90f6cc5b.svg";